import { CFImage } from '../../type/client-index'

export const BiscuitEmpt: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/80fcda6e-ceca-4b78-86d4-8b814f81d200/1500',
  width: 560,
  height: 704
}

export const BiscuitTag: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/5d1c527d-9452-4969-f0e2-48504160ff00/1500',
  width: 560,
  height: 704
}

export const Schema1: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/b40cb13c-cddf-4602-04fe-6598e4318500/2500',
  width: 2500,
  height: 686
}
